/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of auditable actions */
export enum AuditAction {
  AgentRegistered,
  AgentUpdated,
  AgentDeactivated,
  AgentVerified,
  PaymentProcessed,
  EscrowCreated,
  EscrowReleased,
  FundsWithdrawn,
  ProposalCreated,
  VoteCast,
  ProposalExecuted,
  GovernanceUpdated,
  AccessGranted,
  AccessRevoked,
  SecurityPolicyUpdated,
  SuspiciousActivity,
  ComplianceReportGenerated,
  RegulatorySubmission,
  AuditRequested,
  ViolationDetected,
  SystemConfigUpdated,
  EmergencyAction,
  MaintenancePerformed,
  WorkOrderCreated,
  WorkOrderCompleted,
  DisputeRaised,
  DisputeResolved,
  MultisigCreated,
  MultisigSigned,
  MultisigExecuted,
  RiskAssessmentPerformed,
  RiskThresholdExceeded,
  RiskMitigationApplied,
}

export type AuditActionArgs = AuditAction;

export function getAuditActionEncoder(): FixedSizeEncoder<AuditActionArgs> {
  return getEnumEncoder(AuditAction);
}

export function getAuditActionDecoder(): FixedSizeDecoder<AuditAction> {
  return getEnumDecoder(AuditAction);
}

export function getAuditActionCodec(): FixedSizeCodec<
  AuditActionArgs,
  AuditAction
> {
  return combineCodec(getAuditActionEncoder(), getAuditActionDecoder());
}
